// extracted by mini-css-extract-plugin
module.exports = {"shareButtonWrapper":"styles_shareButtonWrapper__3ECmo","shareButton":"styles_shareButton__1-fug","shareIcon":"styles_shareIcon__1-0ZN"};